<template>
  <div class="mymenu" :class="type == 2 ? 'mymenu2' : ''">
    <template v-if="type == 2">
      <div class="pao menu_pao1 pao_trends"></div>
      <div class="pao menu_pao2 pao_trends"></div>
      <div class="pao menu_pao3 pao_trends"></div>
      <img class="pao menu_pao4" src="@/assets/notice2.png">
    </template>
    <div class="nav nav1">
      <div class="nav1_item left">
        <a href="https://www.fangte.com/" target="_blank" class="logo">
          <img class="l lvyou_logo" :src="type == 2 ? require('@/assets/logo3.png') : require('@/assets/logo1.png')" />
        </a>
        <a href="https://www.fantawild.com/" target="_blank">华强方特</a>
        <a href="https://www.hqftdm.com/" target="_blank">方特动漫</a>
      </div>
      <div class="nav1_item right">
        <div class="header_trSelect">
          <span>选择主题乐园</span>
          <img :src="type == 2 ? require('@/assets/arrow11.png') : require('@/assets/arrow1.png')">
          <ul class="header_trList" id="parkMenu">
            <li v-for="(v, k) in parkList" :key="k">
              <a :href="v.park_url" target="_blank">
                {{ v.park_area }}
              </a>
              <ul class="header_trUl" v-if="v.parks && v.parks.length">
                <li v-for="(val, key) in v.parks" :key="key">
                  <a :href="val.park_url" target="_blank">{{ val.park_name }}</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="header_trSelect">
          <span>选择方特酒店</span>
          <img :src="type == 2 ? require('@/assets/arrow11.png') : require('@/assets/arrow1.png')">
          <ul class="header_trList" id="hotelMenu">
            <li v-for="(v, k) in hotelList" :key="k">
              <a :href="v.park_url" target="_blank">
                {{ v.park_name }}
              </a>
              <ul class="header_trUl" v-if="v.parks && v.parks.length">
                <li v-for="(val, key) in v.parks" :key="key">
                  <a :href="val.park_url" target="_blank">{{ val.cname }}</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="tel">方特全国服务热线： 400-166-0006</div>
      </div>
    </div>
    <div class="nav nav2">
      <img src="@/assets/logo2.png" @click="$toPage('/')">
      <ul>
        <li v-for="(v, k) in menu" :key="k" :style="{
          width: v.width
        }" :class="{
          'nav2_show': menuShow,
          'nav2_active': menuIndex == k,
        }">
          <a @click="$toPage(v.href)">{{ k == 0 ? '首&nbsp;&nbsp;&nbsp;&nbsp;页' : v.name }}</a>
          <div class="nav2_list" v-if="v.list">
            <a class="nav2_list_item" v-for="(val, key) in v.list" :key="key" @click.stop="toPage(val)">{{ val.name }}</a>
          </div>
        </li>
      </ul>
    </div>
    <!-- <div class="myPopup" v-if="myPopupShow">
      <div class="myPopup_box">
        <div class="myPopup_main">
          <img src="@/assets/icon_tip.png" alt="" srcset="">
          <p>暂未开放 敬请期待!</p>
        </div>
        <div class="myPopup_close" @click="myPopupShow = false"></div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    type: {
      default: 1,
      type: [Number, String],
    }
  },
  data() {
    return {
      menuShow: false,
      menuIndex: 0,
      menu: [
        { name: '首页', href: '/', width: '3em' },
        {
          name: '欢乐港湾', href: '/adventurePark', list: [
            { name: '开放式主题街区', href: '/adventurePark', },
            { name: '熊出没水上乐园', href: '/waterPark', },
            { name: '休闲娱乐', href: '/entertainment', },
            { name: '特选美食', href: '/catering', },
            { name: '特享购物', href: '/shopping', },
            { name: '精选住宿', href: '/hotel', },
          ]
        },
        {
          name: '精彩活动', href: '/theme', list: [
            { name: '主题活动', href: '/theme', },
            { name: '动态公告', href: '/news', },
          ]
        },
        {
          name: '园区服务', href: '/parkMap', list: [
            { name: '园区地图', href: '/parkMap', },
            { name: '交通指南', href: '/traffic', },
          ]
        },
        {
          name: '关于我们', href: '/aboutUs', list: [
            { name: '招商合作', href: '/aboutUs', },
            { name: '方特旅游', href: 'https://www.fangte.com', },
          ]
        },
      ],
      parkList: [],
      hotelList: [],
      myPopupShow: false,
    }
  },
  methods: {
    toPage(val) {
      // if (val.name == '熊出没水上乐园') {
      //   $('.noOpen').addClass('myPopup_box_show')

      //   return this.myPopupShow = true
      // }
      this.$toPage(val.href)
    },
    getParksHotels() {
      P_getParkList().then(res => {
        if (res.success) {
          this.parkList = res.park || [];
          this.hotelList = res.hotel || [];
        }
      })
    },
    // 重定向移动端
    uaredirect() {
      var f = this.$parkData.park_murl;
      try {
        if (document.getElementById("bdmark") != null) {
          return
        }
        var b = false
        if (arguments[1]) {
          var e = window.location.host
          var a = window.location.href
          if (isSubdomain(arguments[1], e) == 1) {
            f = f + "/#m/" + a
            b = true
          } else {
            if (isSubdomain(arguments[1], e) == 2) {
              f = f + "/#m/" + a
              b = true
            } else {
              f = a
              b = false
            }
          }
        } else {
          b = true
        }
        if (b) {
          var c = window.location.hash
          if (!c.match("fromapp")) {
            if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
              location.replace(f)
            }
          }
        }
      } catch (d) { }
    },
    setZoom() {
      this.uaredirect();
      var ww = document.documentElement.clientWidth;
      var mainDom = document.getElementById('app');
      var that = this;
      function scaleHTML(flag) {
        ww = document.documentElement.clientWidth;
        that.zoom = ww / 1920
        flag && that.$emit('zoomChange', that.zoom);
        mainDom.style.zoom = that.zoom;
        var explorer = window.navigator.userAgent;
        if (explorer.indexOf("Firefox") >= 0) { // 火狐浏览器不支持zoom
          $("#page").css({
            '-moz-transform': 'scale(' + that.zoom + ')',
            '-moz-transform-origin': 'left top',
            'width': (1 / that.zoom) * 100 + '%'
          });
        }
      }
      scaleHTML(true);
      var time = null;
      window.onresize = () => {
        scaleHTML();
        if (time !== null) {
          clearTimeout(time);
        }
        time = setTimeout(() => { //防抖
          this.uaredirect();
          this.$emit('zoomChange', that.zoom);
        }, 500);
      }
    },
    setMenu() {
      let index = 0;
      let path = this.$route.path;
      this.menu.forEach((v, k) => {
        if (v.href == path) {
          index = k;
        }
        v.list && v.list.forEach(val => {
          if (val.href == path) {
            index = k;
          }
        })
      });
      this.menuIndex = index;
    }
  },
  created() {
    this.setMenu();
  },
  mounted() {
    this.getParksHotels();
    $(".header_trSelect").hover(
      function () {
        $(this).find(".header_trList").stop().fadeIn();
      },
      function () {
        $(this).find(".header_trList").stop().fadeOut();
      }
    );
    $(".header_trList li").hover(
      function () {
        $(this).find(".header_trUl").stop().fadeIn();
      },
      function () {
        $(this).find(".header_trUl").stop().fadeOut();
      }
    );
    this.setZoom();
  }
}
</script>

<style lang="scss" scoped>
.mymenu {
  position: relative;
  .nav1 {
    font-size: 16px;
    color: #fff;
    width: 100%;
    height: 48px;
    background-color: #f69429;
    padding: 0 194px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 3;
    .left {
      a {
        margin-right: 22px;
      }
    }
    .logo {
      margin-right: 25px;
      font-size: 0;
    }
    .header_trSelect {
      width: 170px;
      line-height: 30px;
      border: 1px solid #fff;
      float: left;
      text-align: center;
      position: relative;
      cursor: pointer;
      margin-right: 25px;
      border-radius: 5px;
      img {
        margin-left: 7px;
      }
    }
    .header_trSelect.area {
      width: 120px;
    }
    .tel {
      margin-left: 5px;
    }
    .nav1_item {
      display: flex;
      align-items: center;
    }
  }
  .header_trList {
    width: 100%;
    background: #f69429;
    position: absolute;
    z-index: 5;
    display: none;
  }

  .header_trList li {
    width: 100%;
    position: relative;
    cursor: pointer;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
    a {
      font-size: 14px;
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .header_trList li:hover {
    background-color: #fff1db;
    color: #f69429;
  }

  .header_trList li:hover .header_trUl {
    display: block;
  }

  .header_trUl {
    width: 166px;
    background: #f69429;
    position: absolute;
    top: 0;
    right: 0px;
    transform: translate(100%, 0);
    display: none;
    color: #5b1e0b;
  }
  .nav2 {
    position: relative;
    z-index: 2;
    width: 1426px;
    font-size: 24px;
    color: #1e1e1e;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 33px auto 0;
    img {
      cursor: pointer;
      width: 205px;
    }
    ul {
      position: relative;
      li {
        display: inline-block;
        margin-right: 72px;
        cursor: pointer;
        transition: all 0.3s;
        position: relative;
        &:hover {
          color: #fa6e19;
        }
        &:last-child {
          margin-right: 0;
        }
        &::after {
          content: '';
          height: 4px;
          background-color: #fa6e19;
          position: absolute;
          left: 50%;
          bottom: -6px;
          transform: translate(-50%, 0);
          transition: width 0.3s;
          width: 0;
        }
      }
      .nav2_list {
        position: absolute;
        left: 50%;
        top: 42px;
        transform: translate(-50%, 0);
        border-radius: 20px;
        border: 1px solid #fff;
        width: 170px;
        text-align: center;
        text-align-last: auto;
        line-height: 2;
        background: rgba($color: #f3a951, $alpha: 0.9);
        color: #fff;
        font-size: 20px;
        overflow: hidden;
        transition: all 0.6s;
        padding: 12px 0;
        max-height: 0;
        opacity: 0;
        .nav2_list_item {
          display: inline-block;
          border-radius: 6px;
          width: 150px;
          margin: 0 auto;
          transition: all 0.3s;
          &:hover {
            background: #fff;
            color: #e55125;
          }
        }
      }
      .nav2_active {
        color: #fa6e19;
        &::after {
          background-color: #fa6e19;
          width: 100%;
        }
      }
      li:hover,
      .nav2_show {
        color: #fa6e19;
        &::after {
          background-color: #fa6e19;
          width: 100%;
        }
        .nav2_list {
          max-height: 280px;
          opacity: 1;
        }
      }
      li:nth-child(3):hover,
      li:nth-child(5):hover {
        .nav2_list {
          max-height: 100px;
        }
      }
      li:nth-child(4):hover {
        .nav2_list {
          max-height: 190px;
        }
      }
    }
  }
}
.mymenu2 {
  .menu_pao1 {
    background: rgb(106, 228, 162);
    background: -moz-linear-gradient(
      -67deg,
      rgb(106, 228, 162) 43%,
      rgb(254, 251, 91) 100%
    );
    background: -webkit-linear-gradient(
      -67deg,
      rgb(106, 228, 162) 43%,
      rgb(254, 251, 91) 100%
    );
    background: -o-linear-gradient(
      -67deg,
      rgb(106, 228, 162) 43%,
      rgb(254, 251, 91) 100%
    );
    background: -ms-linear-gradient(
      -67deg,
      rgb(106, 228, 162) 43%,
      rgb(254, 251, 91) 100%
    );
    background: linear-gradient(
      -67deg,
      rgb(106, 228, 162) 43%,
      rgb(254, 251, 91) 100%
    );
    left: -230px;
    top: -126px;
    width: 400px;
    height: 400px;
    opacity: 0.7;
    animation: pao_trends 6s ease-in-out infinite,
      pao_trends2 16s linear infinite forwards;
    overflow: hidden;
  }
  .menu_pao2 {
    background: rgb(149, 219, 255);
    background: -moz-linear-gradient(
      111deg,
      rgb(149, 219, 255) 0%,
      rgb(66, 128, 253) 100%
    );
    background: -webkit-linear-gradient(
      111deg,
      rgb(149, 219, 255) 0%,
      rgb(66, 128, 253) 100%
    );
    background: -o-linear-gradient(
      111deg,
      rgb(149, 219, 255) 0%,
      rgb(66, 128, 253) 100%
    );
    background: -ms-linear-gradient(
      111deg,
      rgb(149, 219, 255) 0%,
      rgb(66, 128, 253) 100%
    );
    background: linear-gradient(
      111deg,
      rgb(149, 219, 255) 0%,
      rgb(66, 128, 253) 100%
    );
    opacity: 0.8;
    right: -150px;
    top: -550px;
    width: 1036px;
    height: 1036px;
    animation: pao_trends_1 10s ease-in-out infinite,
      pao_trends2 20s linear infinite forwards;
    overflow: hidden;
  }
  .menu_pao3 {
    background: rgb(106, 228, 162);
    background: -moz-linear-gradient(
      -67deg,
      rgb(106, 228, 162) 43%,
      rgb(254, 251, 91) 100%
    );
    background: -webkit-linear-gradient(
      -67deg,
      rgb(106, 228, 162) 43%,
      rgb(254, 251, 91) 100%
    );
    background: -o-linear-gradient(
      -67deg,
      rgb(106, 228, 162) 43%,
      rgb(254, 251, 91) 100%
    );
    background: -ms-linear-gradient(
      -67deg,
      rgb(106, 228, 162) 43%,
      rgb(254, 251, 91) 100%
    );
    background: linear-gradient(
      -67deg,
      rgb(106, 228, 162) 43%,
      rgb(254, 251, 91) 100%
    );
    right: -358px;
    top: -228px;
    width: 1000px;
    height: 1000px;
    opacity: 0.8;
    animation: pao_trends_1 14s ease-in-out infinite,
      pao_trends2 24s linear infinite forwards;
    overflow: hidden;
  }
  @keyframes pao_trends {
    0% {
      border-radius: 56% 42% 42% 42%;
    }

    25% {
      border-radius: 60% 40% 40% 40%;
    }

    50% {
      border-radius: 64% 44% 44% 44%;
    }

    75% {
      border-radius: 60% 40% 40% 40%;
    }

    100% {
      border-radius: 56% 42% 42% 42%;
    }
  }
  @keyframes pao_trends_1 {
    0% {
      border-radius: 52% 46% 46% 46%;
    }

    25% {
      border-radius: 56% 44% 44% 44%;
    }

    50% {
      border-radius: 60% 48% 48% 48%;
    }

    75% {
      border-radius: 56% 44% 44% 44%;
    }

    100% {
      border-radius: 52% 46% 46% 46%;
    }
  }
  @keyframes pao_trends2 {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .menu_pao4 {
    right: 0;
    top: 0;
  }
  .nav1 {
    background: none;
    color: #5b1e0b;
    .header_trSelect {
      border: 1px solid #5b1e0b;
    }
  }
  .nav2 {
    color: #fff;
    ul {
      li {
        &:hover {
          color: #fffc00;
        }
        &::after {
          background-color: #fffc00;
        }
      }
      .nav2_list {
        background: rgba($color: #f3a951, $alpha: 0.9);
        > div {
          &:hover {
            background: #fff;
            color: #e55125;
          }
        }
      }
      li:hover,
      .nav2_show,
      .nav2_active {
        color: #fffc00;
        &::after {
          background-color: #fffc00;
        }
      }
    }
  }
}
// /弹窗/
.myPopup {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  transition: opacity 0.6s;
}

.myPopup .myPopup_box {
  width: 626px;
  margin: 0 auto;
  position: relative;
  // background: #fff;
}

.myPopup .myPopup_main {
  border-radius: 20px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0px 6px 20px 0px rgba(158, 189, 220, 0.5);
  width: 593px;
  height: 320px;
  position: relative;
  z-index: 1;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 70px;
  }
  p {
    font-size: 24px;
    margin-top: 20px;
  }
}

.myPopup .myPopup_close {
  width: 80px;
  height: 80px;
  background: url('../assets/icon_close.png');
  background-size: 100% 100%;
  cursor: pointer;
  position: absolute;
  top: -40px;
  right: -10px;
  z-index: 2;
  cursor: pointer;
  transition: all 0.5s;
  &:hover {
    transform: rotate(180deg);
  }
}
</style>